import type { UserInfo } from '@grosync/common';
import { apiRequest } from './client';

export interface UserActivityLog {
  id: string;
  userId: string;
  action: string;
  metadata?: Record<string, unknown> | null;
  createdAt: string;
}

export const fetchUsers = (): Promise<UserInfo[]> =>
  apiRequest<UserInfo[]>('/api/users');

export interface CreateUserInput {
  username: string;
  name: string;
  password: string;
  email?: string;
  phone?: string;
  role: string;
}

export const createUser = (body: CreateUserInput): Promise<UserInfo> =>
  apiRequest<UserInfo>('/api/users', {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const updateUser = (
  id: string,
  body: {
    name?: string;
    email?: string;
    phone?: string;
    notes?: string;
    password?: string;
    role?: string;
    isActive?: boolean;
    status?: 'pending' | 'active' | 'dormant';
  },
): Promise<UserInfo> =>
  apiRequest<UserInfo>(`/api/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

/** 승인 대기 회원 승인 → 활성화 */
export const approveUser = (id: string): Promise<UserInfo> =>
  updateUser(id, { status: 'active' });

export const fetchActivityLogs = (id: string): Promise<UserActivityLog[]> =>
  apiRequest<UserActivityLog[]>(`/api/users/${id}/activity`);
